import { GENERIC_URL, customAxios, USERNAME } from '../constants';

export default function(clientes) {
  const promises = [];

  clientes.map((cliente) => {
    const data = {
      codCliente: cliente,
      codDireccion: '',
      estadoTrama: '',
      mensaje: '',
    };
    const config = {
      headers: {
        codUsuario: USERNAME,
      },
    };
    return (
      promises.push(
        customAxios.post(`${GENERIC_URL}/cliente/detalleDirecionListar`,data, config)
          .then(( result ) => {
            if ( result.data.estadoTrama === '1') {
              return { [cliente]: [result.data.ubigeoDireccion] };
            }
            return 'error';
          })
      ));
  });
  return Promise.all(promises);
}


// WEBPACK FOOTER //
// ./src/utils/getClienteDirecciones.js